import { Row, FormSelect, FormInput, FormTextArea, Widget } from '@digital/ui'
import React from 'react'
import ptBR from '@app/i18n/ptBR'
import { getAllTipoNaoPrevistoOptions } from '@app/api/naoPrevistos/parametros';
import { solicitacaoState } from '../../../atoms';
import { useRecoilState } from 'recoil';
import { updateSolicitacaoNaoPrevisto } from '@app/api/naoPrevistos/solicitacao';
import { Collapse, Icon, Checkbox, Switch, Divider } from 'antd';
import { EStatusSolicitacaoNaoPrevisto } from '@app/enums/ENaoPrevisto';

const { Panel } = Collapse;

interface IMotivadorDoCapexNaoPrevistoProps {
  noCollapse?: boolean;
}

const MotivadorDoCapexNaoPrevisto = ({ noCollapse }: IMotivadorDoCapexNaoPrevistoProps) => {
  const [solicitacao, setSolicitacao] = useRecoilState(solicitacaoState);

  const onBlur = (e: any) => {
    if (solicitacao[e.currentTarget.name] === e.currentTarget.value) return
    const values = { ...solicitacao, [e.currentTarget.name]: e.currentTarget.value }
    updateSolicitacaoNaoPrevisto(values).then(() => {
      setSolicitacao((prev) => (prev ? { ...prev, [e.currentTarget.name]: e.currentTarget.value } : prev))
    })
  }

  const onChangeField = (e: any) => {
    const { name, value } = e.target
    setSolicitacao((prev) => (prev ? { ...prev, [name]: value } : prev))
  }

  const onSelect = (value: any, property: string) => {
    if (solicitacao[property] === value) return
    const values = { ...solicitacao, [property]: value }
    updateSolicitacaoNaoPrevisto(values).then(() => {
      setSolicitacao((prev) => (prev ? { ...prev, [property]: value } : prev))
    })
  }

  const content = (
        <Widget
          title=""
          actions={[]}>

          <Row>
            <FormInput
              span={12}
              name='nomeProjeto'
              label={ptBR.lblNomeDoProjeto}
              value={solicitacao.nomeProjeto ?? ''}
              onChange={onChangeField}
              onBlur={onBlur}
              disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
            />
          </Row>

          <Row>
            <FormTextArea
              span={10}
              rows={6}
              name='escopo'
              label={ptBR.lblEscopoDoProjetoEOuInvestimento}
              placeholder={ptBR.placeholder_escopo}
              value={solicitacao.escopo ?? ''}
              onChange={onChangeField}
              onBlur={onBlur}
              disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
            />

            <FormTextArea
              span={2}
              name='vidaUtilEmMeses'
              label={ptBR.lblVidaUtilEmMeses}
              placeholder={ptBR.placeholder_vidaUtilEmMeses}
              value={solicitacao.vidaUtilEmMeses ?? ''}
              onChange={onChangeField}
              onBlur={onBlur}
              disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
            />
          </Row>
          <Row>
            <FormTextArea
              span={12}
              rows={4}
              name='porQueAgora'
              placeholder={ptBR.placeholder_porQueAgora}
              label={ptBR.lblPorQueAgora}
              value={solicitacao.porQueAgora ?? ''}
              onChange={onChangeField}
              onBlur={onBlur}
              disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
            />
          </Row>

          <fieldset>
            <legend className='legend-float-left'>{ptBR.lblMotivadorDoCapExNaoPrevisto}</legend>

            <Row>
              <FormSelect
                span={4}
                name='tipoNaoPrevistoId'
                label={ptBR.lblTipo}
                value={solicitacao.tipoNaoPrevistoId}
                getOptions={getAllTipoNaoPrevistoOptions}
                onSelect={(value) => onSelect(value, 'tipoNaoPrevistoId')}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />

              <FormTextArea
                span={12}
                rows={4}
                name='observacao'
                placeholder={ptBR.placeholder_observacao}
                label={ptBR.lblObservacao}
                value={solicitacao.observacao ?? ''}
                onChange={onChangeField}
                onBlur={onBlur}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />

            </Row>
          </fieldset>

        </Widget>
  );

  if (noCollapse) return content;
  return (
    <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
      <Panel key="2" header={ptBR.lblProjeto} style={{ border: 0 }}>
        {content}
      </Panel>
    </Collapse>
  );
}

export default MotivadorDoCapexNaoPrevisto